<template>
	<div ref="root" class="watermark-host" aria-hidden="true">
		<div class="watermark-token-host"></div>
		<span
			v-for="position in positions"
			:key="position"
			:class="['watermark-text', `watermark-text--${position}`]"
		>
			{{ watermarkText }}
		</span>
	</div>
</template>

<script>
const MIN_ID = 1
const MAX_ID = 10000

function normalizeId(value) {
	const id = Number(value)
	if (!Number.isInteger(id) || id < MIN_ID || id > MAX_ID) return null
	return id
}

function createPageId(route) {
	const key = (route && (route.name || route.path)) || 'unknown'
	let hash = 0

	for (let index = 0; index < key.length; index += 1) {
		hash = (hash * 31 + key.charCodeAt(index)) % MAX_ID
	}

	return hash + MIN_ID
}

export default {
	name: 'LightWatermark',
	data() {
		return {
			instance: null,
			currentDate: this.$dayjs().format('YYYY-MM-DD'),
			positions: [
				'top-left',
				'top-center',
				'top-right',
				'middle-left',
				'middle-center',
				'middle-right',
				'bottom-left',
				'bottom-center',
				'bottom-right'
			]
		}
	},
	computed: {
		userId() {
			return normalizeId(this.$store.state.user.id)
		},
		watermarkText() {
			const account = this.$store.state.user.name
			return account ? `crm-${account} ${this.currentDate}` : ''
		},
		pageId() {
			return createPageId(this.$route)
		}
	},
	watch: {
		userId() {
			this.syncWatermark()
		},
		pageId() {
			this.syncWatermark()
		}
	},
	mounted() {
		this.syncWatermark()
	},
	beforeDestroy() {
		this.destroyWatermark()
	},
	methods: {
		syncWatermark() {
			if (!this.userId) {
				this.destroyWatermark()
				return
			}

			const sdk = window.LightWatermarkSDK
			if (!sdk) {
				return
			}

			const config = {
				id: this.userId,
				pageId: this.pageId,
				fontSize: 18,
				fontColor: 'rgba(255, 255, 255, 0)',
				width: 250,
				height: 30,
				zIndex: 1,
				invisible: true
			}

			if (this.instance) {
				this.instance.update(config)
				return
			}

			this.instance = sdk.mount(this.$refs.root, config)
		},
		destroyWatermark() {
			if (this.instance) {
				this.instance.destroy()
				this.instance = null
			}
		}
	}
}
</script>

<style lang="less" scoped>
.watermark-host {
	position: fixed;
	inset: 0;
	z-index: 1000;
	line-height: normal;
	pointer-events: none;
}

.watermark-token-host {
	position: absolute;
	top: 50%;
	left: 50%;
	opacity: 0;
	transform: translate(-50%, -50%);
}

.watermark-text {
	position: absolute;
	z-index: 2;
	color: rgba(45, 140, 240, 0.05);
	font-family: 'Courier New', Courier, monospace;
	font-size: 20px;
	font-weight: 700;
	white-space: nowrap;
	transform: translate(-50%, -50%) rotate(-12deg);
}

.watermark-text--top-left {
	top: 16%;
	left: 16%;
}

.watermark-text--top-center {
	top: 16%;
	left: 50%;
}

.watermark-text--top-right {
	top: 16%;
	left: 84%;
}

.watermark-text--middle-left {
	top: 50%;
	left: 16%;
}

.watermark-text--middle-center {
	top: 50%;
	left: 50%;
}

.watermark-text--middle-right {
	top: 50%;
	left: 84%;
}

.watermark-text--bottom-left {
	top: 84%;
	left: 16%;
}

.watermark-text--bottom-center {
	top: 84%;
	left: 50%;
}

.watermark-text--bottom-right {
	top: 84%;
	left: 84%;
}
</style>
